/**
 * Google Analytics 4 measurement ID.
 *
 * Paste the ID from the GA4 property here (Admin > Data streams > Web).
 * While it is empty nothing is loaded and no requests are made — the funnel
 * events in `src/lib/funnel.ts` still queue harmlessly in `window.dataLayer`.
 *
 * Consent Mode v2 is already initialised in index.html and defaults to denied,
 * so GA4 runs cookieless until the visitor accepts the cookie banner.
 */
export const GA_MEASUREMENT_ID = '';
